import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Style from "../../assets/css/main.module.css";
import membershipLightIcon from "../../assets/icons/membership-light.svg";
import membershipIcon from "../../assets/icons/membership.svg";
import packageLightIcon from "../../assets/icons/package-light.svg";
import packageIcon from "../../assets/icons/package.svg";
import ticketLightIcon from "../../assets/icons/ticket-light.svg";
import ticketIcon from "../../assets/icons/ticket.svg";
import Memberships from "./Memberships";
import Packages from "./Packages";
import Tickets from "./Tickets";

export default function Ticket({ park }) {
  const [tab, setTab] = useState("tickets");
  const { branches, selectedBranch } = useSelector((state) => state.branchSlice);
  const [hasTicket, setHasTicket] = useState(false);
  const [hasPackage, setHasPackage] = useState(false);
  const [hasMembership, setHasMembership] = useState(false);

  useEffect(() => {
    localStorage.setItem('ticketType', tab)
    if (branches) {
      const finding = branches.find(
        (item) => item.id === Number(selectedBranch)
      );

     // Check if sections have actual content, not just the array existence
    const hasTicketContent = !!(finding?.has_ticket?.length > 0);
    const hasPackageContent = !!(finding?.has_package?.length > 0);
    const hasMembershipContent = !!(finding?.has_membership?.length > 0);

      setHasTicket(hasTicketContent);
      setHasPackage(hasPackageContent);
      setHasMembership(hasMembershipContent);

      // Set initial tab based on content availability
      if (!hasTicketContent && tab === "tickets") {
        if (hasPackageContent) setTab("packages");
        else if (hasMembershipContent) setTab("membership");
      }
    }
  }, [branches, selectedBranch, tab]);

  // Update the default tab if the current one isn't available
  useEffect(() => {
    if (tab === "tickets" && !hasTicket) {
      if (hasPackage) setTab("packages");
      else if (hasMembership) setTab("membership");
    } else if (tab === "packages" && !hasPackage) {
      if (hasTicket) setTab("tickets");
      else if (hasMembership) setTab("membership");
    } else if (tab === "membership" && !hasMembership) {
      if (hasTicket) setTab("tickets");
      else if (hasPackage) setTab("packages");
    }
  }, [tab, hasTicket, hasPackage, hasMembership]);

  // Hide entire section if none of the three are active
  if (!hasTicket && !hasPackage && !hasMembership) {
    return null;
  }

  return (
    <div className="d-flex flex-column h-100">
      <div className="d-flex flex-column gap-2 pt-2 px-2">
        <div className={`${Style.fw_400} ${Style.ticket_park_text} d-flex align-items-center`}>
          <div>
            Your next{" "}
            <span className={`${Style.text_primary} ${Style.fw_600}`}>
              {park.name}
            </span>{" "}
            adventure awaits. Book tickets now!
          </div>
        </div>
        {/* Buttons Section - Ordered by priority */}
        <div className="d-flex flex-wrap justify-content-center justify-content-md-start gap-3 gap-md-2">
          {/* Tickets Button - Highest priority */}
          {hasTicket && (
            <button
              type="button"
              onClick={() => setTab("tickets")}
              className={
                tab === "tickets"
                  ? `${Style.bg_primary} ${Style.fw_400} ${Style.fs_16} text-light border-0 d-flex flex-column align-items-center justify-content-center py-2 px-md-5`
                  : `${Style.bg_gray_200} ${Style.fw_400} ${Style.fs_16} ${Style.text_primary} border-0 d-flex flex-column align-items-center justify-content-center py-2 px-md-5`
              }
              style={{ width: "230px", height: "82px" }}
            >
              <div>
                <img
                  src={tab === "tickets" ? ticketLightIcon : ticketIcon}
                  alt="ticket"
                />
              </div>
              <div>Buy Tickets</div>
            </button>
          )}
          {/* Packages Button - Second priority */}
          {hasPackage && (
            <button
              type="button"
              onClick={() => setTab("packages")}
              className={
                tab === "packages"
                  ? `${Style.bg_primary} ${Style.fw_400} ${Style.fs_16} text-light border-0 d-flex flex-column align-items-center justify-content-center py-2 px-md-5`
                  : `${Style.bg_gray_200} ${Style.fw_400} ${Style.fs_16} ${Style.text_primary} border-0 d-flex flex-column align-items-center justify-content-center py-2 px-md-5`
              }
              style={{ width: "230px", minHeight: "82px" }}
            >
              <div>
                <img
                  src={tab === "packages" ? packageLightIcon : packageIcon}
                  alt="package"
                />
              </div>
              <div>Buy Packages</div>
            </button>
          )}
          {/* Membership Button - Third priority */}
          {hasMembership && (
            <button
              type="button"
              onClick={() => setTab("membership")}
              className={
                tab === "membership"
                  ? `${Style.bg_primary} ${Style.fw_400} ${Style.fs_16} text-light border-0 d-flex flex-column align-items-center justify-content-center py-2 px-md-5`
                  : `${Style.bg_gray_200} ${Style.fw_400} ${Style.fs_16} ${Style.text_primary} border-0 d-flex flex-column align-items-center justify-content-center py-2 px-md-5`
              }
              style={{ width: "230px", minHeight: "82px" }}
            >
              <div>
                <img
                  src={tab === "membership" ? membershipLightIcon : membershipIcon}
                  alt="membership"
                />
              </div>
              <div>Buy Memberships</div>
            </button>
          )}
        </div>
      </div>
      {/* Content Sections - Only render if section has content */}
      <div className="w-100 flex-grow-1 h-100">
        {tab === "tickets" && hasTicket && (
          <div className={`${Style.bg_primary_200} mt-2 p-2`}>
            <Tickets park={park} />
          </div>
        )}
        {tab === "packages" && hasPackage && (
          <div className={`${Style.bg_primary_200} mt-2 p-2`}>
            <Packages />
          </div>
        )}
        {tab === "membership" && hasMembership && (
          <div className={`${Style.bg_primary_200} mt-2 p-2`}>
            <Memberships />
          </div>
        )}
      </div>
    </div>
  );
}